magna.accordion = (selector, expandFirst = false, callback = null) => {
  const elements = document.querySelectorAll(selector);

  elements.forEach((el) => {
    el.addEventListener('click', function () {
      elements.forEach((child) => {
        if (child !== this) child.classList.remove('accordion--active');
      });
      this.classList.toggle('accordion--active');

      callback && callback(this);
    });
  });

  if (expandFirst) elements[0].classList.toggle('accordion--active');
};
